// Import stylesheets
import '~/stylesheets/application.scss'

// Import CSS files directly (not through SCSS)
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'spectrum-colorpicker2/dist/spectrum.min.css'
import 'dropzone/dist/dropzone.css'
import 'jquery-ui-dist/jquery-ui.min.css'
import flatpickr from 'flatpickr';
import "flatpickr/dist/flatpickr.min.css";
//import "flatpickr/dist/themes/dark.css";

import * as Turbo from '@hotwired/turbo'
Turbo.start();


// Import jQuery as a module (required for picker.js UMD wrapper)
// jQuery is also loaded from CDN for inline scripts, but we need it as a module
// for Vite to properly resolve dependencies in UMD files
import $ from 'jquery'
// Ensure global availability for inline scripts and other code expecting window.jQuery
window.jQuery = window.$ = $

// Note: jQuery UI is already loaded in foundation.js entry point
// Import plugins
import 'trumbowyg'

// Import Rails dependencies
import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'

// Start Rails UJS and ActiveStorage
Rails.start()
ActiveStorage.start()

// Configure CSRF token for AJAX requests
// Rails UJS should handle this automatically, but we ensure it works for all AJAX requests
// This handles both Rails UJS and direct jQuery AJAX calls
$.ajaxSetup({
  beforeSend: function(xhr, settings) {
    if (!settings.crossDomain && !/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type)) {
      const token = $('meta[name="csrf-token"]').attr('content')
      if (token) {
        xhr.setRequestHeader('X-CSRF-Token', token)
      }
    }
  }
})

// Note: Turbo is loaded via turbo_include_tags in layout, don't import here to avoid double initialization

// Foundation is loaded separately via foundation.js entry point

// Import Chart.js
import Chart from 'chart.js/auto'
window.Chart = Chart

// Import third-party libraries that exist as files
// Use npm package for spectrum-colorpicker2 instead of local file
import 'spectrum-colorpicker2'

import '~/lib/serviceworker-companion.js'
import '~/lib/printThis.js'
import '~/lib/pull_to_refresh.js'

// Note: jquery.cookie is now available as a package, but keeping the local file if it has customizations
import 'jquery.cookie'

// Import custom modules
import '~/modules/dashboard_layout.js'
import '~/modules/jobs.js'
import '~/modules/projects.js'
import '~/modules/quotes.js'
import '~/modules/items.js'
import '~/modules/products.js'
import '~/modules/papers.js'
import '~/modules/statuses.js'
import '~/modules/retainers.js'
import '~/modules/invoices.js'
import '~/modules/time_entries.js'
import '~/modules/dashboard.js'
import '~/modules/trumbowyg.js'
import '~/modules/todos.js'
import '~/modules/cable.js'
import '~/modules/forms.js'
import '~/modules/statuses_page.js'
import '~/modules/todos_page.js'
import '~/modules/panelizer.js'

// Import utilities
import '~/utils/show_spinner.js'
import '~/utils/currency.js'
import '~/utils/sidebar.js'

// Window resize handlers
$(window).on('load', function() {
  $('body').height($(window).height())
})

$(window).on('resize', function() {
  $('body').height($(window).height())
})

// Document ready handler
$(document).ready(function() {
  // Add initialization code here
})

// Turbo event handlers
$(document).on('turbo:load', function(event) {
  $(document).foundation()
  // Update CSRF token in AJAX setup when Turbo loads new content
  // This ensures the token is current after Turbo navigation
  const token = $('meta[name="csrf-token"]').attr('content')
  if (token) {
    $.ajaxSetup({
      beforeSend: function(xhr, settings) {
        if (!settings.crossDomain && !/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type)) {
          xhr.setRequestHeader('X-CSRF-Token', token)
        }
      }
    })
  }
})

// General handler for closing modals via data-close attribute
$(document).on('click', '[data-close]', function(e) {
  e.preventDefault()
  var modalId = $(this).data('close')
  $('#' + modalId).foundation('close')
})

$(document).on('turbo:frame-render', function(event) {
  if ($('turbo-frame#main-body').length > 1) {
    // Fix duplicate main-body frames
    var main_content = $('turbo-frame#main-body').last().html()
    $('turbo-frame#main-body').last().remove()
    $('turbo-frame#main-body').html(main_content)
  }
})
